// should match .main-line-row height
const BUFFER = 30;

/**
 * Determines if the move list is scrolled up from bottom, with a buffer of one row.
 */
export function isMoveListScrolledUp(container: HTMLElement): boolean {
  return container.scrollHeight - container.scrollTop - container.clientHeight >= BUFFER;
}
